import * as ReactDOM from 'react-dom/client';
import { datadogLogs } from '@datadog/browser-logs';
import { environment } from './environment';
import './reset.css';

import '@teamworksdev/style/dist/index.css';
import '@teamworksdev/nav/dist/index.css';
import './styles.css';

import Root from './root';

console.log(`Teamworks Strength version ${environment.VITE_COMMIT_SHA}`);

// When a deploy replaces a hashed chunk that a stale browser session is still trying to load,
// Vite fires this event instead of leaving the user with a broken UI.
window.addEventListener('vite:preloadError', (event) => {
  datadogLogs.logger.error(
    'vite:preloadError — reloading to recover stale chunk',
    {
      error: event.payload,
    },
  );
  window.location.reload();
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(<Root />);
